import { render } from "./SurveyPage.vue?vue&type=template&id=18658478"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__